import { Box, Button, Container, LoadingOverlay, Modal } from '@mantine/core'
import { BerthForm } from '../components/BerthForm'
import { useDisclosure, useMediaQuery, usePrevious } from '@mantine/hooks'
import { IconPlus } from '@tabler/icons-react'
import '@mantine/dates/styles.css'
import { useState } from 'react'
import { PeriodPicker } from '../components/PeriodPicker'
import classes from './CalendarPage.module.css'
import { useParams } from 'react-router-dom'
import { useBerthsByPeriod } from '../api/marina'
import { Calendar } from '../components/Calendar'

// TODO: use marinaId to fetch

export function CalendarPage() {
  const { marinaId } = useParams()
  const [opened, { open, close }] = useDisclosure(false)
  const [period, setPeriod] = useState<Date>(new Date())
  const isSmallScreen = useMediaQuery('(max-width: 640px)')

  const {
    data: berths,
    isPending: berthsPending,
    //isError: berthsError,
  } = useBerthsByPeriod(marinaId ?? '', period)
  const previousBerths = usePrevious(berths)

  return (
    <div className={classes.container}>
      <Modal
        opened={opened}
        onClose={close}
        title="Add Berths"
        fullScreen={isSmallScreen}
        transitionProps={{ transition: 'fade', duration: 200 }}
      >
        <BerthForm marinaId={marinaId} onCancel={close} />
      </Modal>
      <div className={classes.subnav}>
        <Container
          size="xl"
          style={{
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            gap: isSmallScreen ? 10 : 0,
          }}
        >
          <PeriodPicker period={period} onChange={setPeriod} />
          <Box flex="1" style={{ textAlign: 'center' }}></Box>
          <Button
            variant="filled"
            color="green"
            leftSection={<IconPlus size={20} />}
            onClick={open}
            maw={isSmallScreen ? '230px' : '100%'}
            size={isSmallScreen ? 'md' : 'lg'}
          >
            Add Available Berths
          </Button>
        </Container>
      </div>
      <Box className={classes.calendar}>
        <LoadingOverlay visible={berthsPending} />

        <Container size="xl">
          <Calendar
            marinaId={parseInt(marinaId || '0', 10)}
            period={period}
            berths={berths || previousBerths || []}
            onAddBerths={open}
          />
        </Container>
      </Box>
    </div>
  )
}
